@if (editIcon) {
  <span class="editIconCell"><span><img class="editIcon"
  src="../../assets/images/icon_edit_default.svg"/></span>{{params.value}}</span>
}

<!-- Currency and Percentage span starts -->
@if ((isCurrency || isPercent) && !isCashSecuritySymbol && !isNotApplicable && !isDoubleDash && !isBlank && !isNegative) {
  <span
    style="float:right;" [style]="{'font-weight': (isBold) ? 'bold' : 'inherit'}">
    @if (params.value < 0) {
      <span style="color:#D30014">
        @if (displaySymbol==='$' && decimalPosition === '0' ) {
          <span>
          ({{displaySymbol}}{{(params.value | number:"1.0-0").replace("-", "")}})</span>
        }
        @if (displaySymbol==='$' && decimalPosition === '1' ) {
          <span>
          ({{displaySymbol}}{{(params.value | number:"1.1-1").replace("-", "")}})</span>
        }
        @if (displaySymbol==='$' && decimalPosition === '2' ) {
          <span>
          ({{displaySymbol}}{{(params.value | number:"1.2-2").replace("-", "")}})</span>
        }
        @if (displaySymbol==='$' && decimalPosition === '3' ) {
          <span>
          ({{displaySymbol}}{{(params.value | number:"1.3-3").replace("-", "")}})</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '0') {
          <span>
          ({{(params.value | number:"1.0-0").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '1') {
          <span>
          ({{(params.value | number:"1.1-1").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '2') {
          <span>
          ({{(params.value | number:"1.2-2").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '3') {
          <span>
          ({{(params.value | number:"1.3-3").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '0') {
          <span>
          ({{(params.value | number:"1.0-0").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '1') {
          <span>
          ({{(params.value | number:"1.1-1").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '2') {
          <span>
          ({{(params.value | number:"1.2-2").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '3') {
          <span>
          ({{(params.value | number:"1.3-3").replace("-", "")}}){{displaySymbol}}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '4') {
          <span>
          ({{(params.value | number:"1.4-4").replace("-", "")}}){{displaySymbol}}</span>
        }
      </span>
    }
    @if (params.value > 0) {
      <span>
        @if (displaySymbol==='$' && decimalPosition === '0') {
          <span
          >{{displaySymbol}}{{params.value | number:"1.0-0" }}</span>
        }
        @if (displaySymbol==='$' && decimalPosition === '1') {
          <span
          >{{displaySymbol}}{{params.value | number:"1.1-1" }}</span>
        }
        @if (displaySymbol==='$' && decimalPosition === '2') {
          <span
          >{{displaySymbol}}{{params.value | number:"1.2-2" }}</span>
        }
        @if (displaySymbol==='$' && decimalPosition === '3') {
          <span
          >{{displaySymbol}}{{params.value | number:"1.3-3" }}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '0') {
          <span
          >{{params.value | number:"1.0-0" }}{{displaySymbol}}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '1') {
          <span
          >{{params.value | number:"1.1-1" }}{{displaySymbol}}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '2') {
          <span
          >{{params.value | number:"1.2-2" }}{{displaySymbol}}</span>
        }
        @if (displaySymbol==='%' && decimalPosition === '3') {
          <span
          >{{params.value | number:"1.3-3" }}{{displaySymbol}}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '0') {
          <span>{{params.value | number:"1.0-0" }}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '1') {
          <span>{{params.value | number:"1.1-1" }}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '2') {
          <span>{{params.value | number:"1.2-2" }}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '3') {
          <span>{{params.value | number:"1.3-3" }}</span>
        }
        @if (displaySymbol===' ' && decimalPosition === '4') {
          <span>{{params.value | number:"1.4-4" }}</span>
        }
      </span>
    }
    @if (!params.value && !nullCheck) {
      <span>
        @if (displaySymbol==='$') {
          <span>{{displaySymbol}}0</span>
        }
        @if (displaySymbol==='%') {
          <span>0{{displaySymbol}}</span>
        }
        @if (displaySymbol===' ') {
          <span>0{{displaySymbol}}</span>
        }
      </span>
      }{{appendToEnd}}
    </span>
  }
  @if ((isCurrency || isPercent) && (isNotApplicable || isDoubleDash || isBlank || isNegative)) {
    <span style="float:right;"
      [style]="{'font-weight': (isBold) ? 'bold' : 'inherit'}">
      @if (isNegative && !(isNotApplicable || isDoubleDash || isBlank)) {
        <span
          [style]="{'color': (displayValue < 0) ? '#D30014' : 'inherit'}">
          @if (decimalPosition === '0') {
            <span>
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.0-0").replace("-", "")}})</span>
          }
          @if (decimalPosition === '1') {
            <span>
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.1-1").replace("-", "")}})</span>
          }
          @if (decimalPosition === '2') {
            <span>
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.2-2").replace("-", "")}})</span>
          }
          @if (decimalPosition === '3') {
            <span>
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.3-3").replace("-", "")}})</span>
          }
          @if (decimalPosition === '4') {
            <span>
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.4-4").replace("-", "")}})</span>
          }
        </span>
      }
      @if (!isNegative || (isNegative && (isNotApplicable || isDoubleDash || isBlank))) {
        <span>
          {{displayValue}}
        </span>
        }{{appendToEnd}}
      </span>
    }

    <!-- Currency and Percentage span ends -->
    @if (isCashSecuritySymbol) {
      <span>n/a</span>
    }

    @if (!linkEnable && !isCurrency && !isPercent && !enablePointer && !params.irbCellActionMenu &&
      !dropdown && !editIcon && !checkbox && !statusFormatter && !errorMsg && !params.template && !statusFormatterWithSomeIcon) {
      <span tooltip
        [tooltipTitle]="toolTipTitle"
        [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true'
      [tooltipHorizontalOffset]='0'>{{appendToStart}} {{params.value}} </span>
    }

    @if (linkEnable && !isCurrency && !isPercent && !editIcon && !columnToolTipInfo && !params.template) {
      <span [style]="{'display': (calltoactionTemplateFunc) ? 'flex' : 'inline'}">
        <a (click)="click()" tooltip
          [tooltipTitle]="toolTipTitle"
          [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>
        {{params.value}}</a>
        <span style="margin-left: auto; line-height: 30px;">
          @if (showHideIcon) {
            <i class="pi pi-eye-slash" style="margin-right: 10px;"></i>
          }
          @if (calltoactionTemplateFunc) {
            <i class="pi pi-ellipsis-v clickable" calltoaction calltoactionPosition="right" [calltoactionTemplate]="calltoactionTemplate" (click)="getCalltoactionTemplate()"></i>
          }
        </span>
      </span>
    }

    @if (linkEnable && !isCurrency && !isPercent && !editIcon &&  !params.template) {
      <span>
        @if (columnToolTipInfo) {
          <div class="cell-dropdown">
            <div class="input-field">
              <a (click)="click()" tooltip [tooltipTitle]="toolTipTitle"
                [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>
              {{params.value}}</a>
              <span class="infoIcon" calltoaction [calltoactionTemplate]="irbColInfoTemplateRef">
                <ng-template #irbColInfoTemplateRef><div [innerHTML]="columnToolTipInfo"></div></ng-template>
              </span>
            </div>
          </div>
        }
      </span>
    }
    @if (enablePointer) {
      <span class="pointer-element">{{params.value}}</span>
    }

    @if (dropdown) {
      <div class="cell-dropdown">
        <div class="input-field">
          <div class="input-field-text" [class]="{'none-selected': params.value==='none'}">{{params.value}}&nbsp;</div>
          <i class="pi pi-chevron-down"></i>
        </div>
      </div>
    }

    @if (statusFormatterWithSomeIcon) {
      <div>
        <div [class]="statusIcon"></div>{{params.value}}
      </div>
    }
    @if (statusFormatter) {
      <div [class]="statusIcon">&nbsp;{{params.value}}</div>
    }
    @if (checkbox) {
      <div class="center checkbox-wrapper" (click)="retainValue($event)">
        <p-checkbox binary="true" [(ngModel)]="params.value" (onChange)="onChange()" [disabled]="params.isCheckboxDisabled"></p-checkbox>
      </div>
    }
    @if (errorMsg) {
      <div style="color: #D30014" tooltip [tooltipTitle]="params.value"
      [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>{{params.value}}</div>
    }

    @if (params.irbCellActionMenu) {
      <div class="cell-dropdown" calltoaction calltoactionPosition="right"
        [calltoactionTemplate]="irbCellActionMenuTemplateRef">
        <div class="input-field">
          <div class="input-field-text">{{params.value}}&nbsp;</div>
          <i class="pi pi-chevron-right"></i>
        </div>
        <ng-template #irbCellActionMenuTemplateRef>
          <div>
            <em class="bold" style="color: #333;padding-bottom: 3px;">{{params.menuHeaderTitle}}</em>
            @for (item of params.irbCellActionMenu; track item) {
              <span>
                <div style="padding: 3px 0 2px 0;border-bottom: 1px solid #ccc;line-height: 16px;">
                  @if (item.click) {
                    <a (click)="item.click()" href="javascript:void(0)">{{ item.label }}</a>
                  }
                  @if (!item.click) {
                    <span>{{ item.label }}</span>
                  }
                </div>
              </span>
            }
          </div>
        </ng-template>
      </div>
    }

    @if (params.template) {
      <div [style]="{'display': (showWarnIcon) ? 'flex' : 'inline', 'justify-content': 'space-between'}">
        @if (showWarnIcon) {
          <span class="icon-warning" style="line-height: 30px;"></span>
        }
        @if (linkEnable) {
          <a (click)="click()" tooltip [tooltipTitle]="params.value"
            [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'
            [innerHTML]="params.template">
          </a>
        }
        @if (!linkEnable) {
          <div tooltip [tooltipTitle]="params.value"
            [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'
            [innerHTML]="params.template">
          </div>
        }
      </div>
    }



